import { MiniIcons } from 'owa-mini-icons';

/**
 * Utility function which returns the chevron icon
 * @param isExpanded True if node is expanded false otherwise
 * @param isRtl True if RTL false otherwise
 */
export default function getChevronIcon(isExpanded: boolean, isRtl: boolean) {
    if (isExpanded) {
        return MiniIcons.ChevronDown;
    }

    return isRtl ? MiniIcons.ChevronLeft : MiniIcons.ChevronRight;
}
